import { createSelector } from 'reselect';
import ItemsHandoverDataAirSummaryColumns
  from '../../containers/ItemsHandoverDataAirSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .ITEMS_WITH_HANDOVER_DATA_AIR_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .ITEMS_WITH_HANDOVER_DATA_AIR_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .ITEMS_WITH_HANDOVER_DATA_AIR_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, ItemsHandoverDataAirSummaryColumns);
